import React from "react";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import { Text, TouchableOpacity, View } from "react-native";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { useTooltips } from "../../../context/WalkthroughContext";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { CropImage } from "../../choose-avatar-components/CropImage";
import Avatar from "../../choose-avatar-components/Avatar";

const WelcomeTooltip = () => {
  const {
    tooltipVisible,
    setTooltipVisible,
    setHomeTooltipVisible,
    setHomeWalkThroughVisible,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();
  const deviceSize = useDeviceSize();
  return (
    <Tooltip
      isVisible={tooltipVisible}
      contentStyle={{
        backgroundColor: AppColors.purple_453B50,
        width:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 350
            : 736,
        borderColor: AppColors.white,
        shadowColor: "rgba(255, 255, 255, 0.65)",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.65,
        shadowRadius: 10.1,
        elevation: 5,
        borderWidth: 1,
      }}
      displayInsets={{
        top: 0,
        bottom:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 0
            : 400,
        left:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 0
            : deviceSize === DEVICE_SIZES.MD
            ? 50
            : 100,
        right: 0,
      }}
      arrowStyle={{ display: "none" }}
      content={
        <View>
          <View
            style={{
              flexDirection:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "column"
                  : "row",
              gap: 10,
            }}
          >
            <TouchableOpacity
              onPress={() => {
                setTooltipVisible(false);
                setHomeWalkThroughVisible(false);
              }}
              style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
            >
              <ImageComponent
                url={AppImages.icCloseWhiteSvg}
                style={{
                  height: 16,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
            <View
              style={{ flexDirection: "row", gap: 10, alignItems: "center" }}
            >
              <Avatar
                src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                variant="walkthroughPlayer"
              />
              {deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ? (
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: AppColors.white }, // Set text color for better readability
                  ]}
                >
                  Welcome to KO 🔥
                </Text>
              ) : null}
            </View>
            <View
              style={{
                flex: 1,
                marginTop:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : 12,
              }}
            >
              <View style={{ gap: 10 }}>
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? null : (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_16,
                      { color: AppColors.white }, // Set text color for better readability
                    ]}
                  >
                    Welcome to KO 🔥
                  </Text>
                )}
                <View>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { lineHeight: 21 },
                    ]}
                  >
                    Where talk is cheap, and only the best rise to the top. Kall
                    out your rivals, stake your claim, and put your skills to
                    the test—all in front of a live audience. Build your rep,
                    win big, and own the moment.
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View
            style={{
              gap: 10,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {/* Dots (Step Indicator) */}
            <View
              style={{
                flexDirection: "row",
                gap: 5,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  ...AppFontStyle.REGULAR_ANYBODY_12,
                  color: AppColors.green_00FFE8,
                }}
              >
                {currentStep + 1} / {totalSteps}
              </Text>
            </View>

            <TouchableOpacity
              onPress={() => {
                setTooltipVisible(false);
                setHomeTooltipVisible(true);
                handleNextStep();
              }}
              style={{
                backgroundColor: AppColors.appViolentColor_6D08C3,
                width: 70,
                height: 20,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 10,
                cursor: "pointer",
                shadowColor: "rgba(0, 0, 0, 0.25)",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.25,
                shadowRadius: 4,
                elevation: 4,
              }}
            >
              <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
            </TouchableOpacity>
          </View>
        </View>
      }
    ></Tooltip>
  );
};

export default WelcomeTooltip;
